import { openDB, type DBSchema, type IDBPDatabase } from 'idb';
import type { Plan, PlanSession, Task, HistoryEntry, NotificationSettings, Preferences, SyncMeta } from '$lib/domain/types';

interface FocusFlowDB extends DBSchema {
  tasks: { key: string; value: Task; indexes: { 'by-status': string } };
  plans: { key: string; value: Plan; indexes: { 'by-status': string; 'by-start': string } };
  plan_sessions: { key: string; value: PlanSession; indexes: { 'by-plan': string } };
  history: { key: string; value: HistoryEntry; indexes: { 'by-plan': string } };
  preferences: { key: string; value: { key: string; value: Preferences } };
  notification_settings: { key: string; value: { key: string; value: NotificationSettings } };
  sync_events: { key: string; value: { id: string; table: string; recordId: string; payload: unknown; updatedAt: string } };
  meta: { key: string; value: SyncMeta };
}

let dbPromise: Promise<IDBPDatabase<FocusFlowDB>> | null = null;

export const getDb = () => {
  if (!dbPromise) {
    dbPromise = openDB<FocusFlowDB>('focus-flow-v4', 1, {
      upgrade(db) {
        const taskStore = db.createObjectStore('tasks', { keyPath: 'id' });
        taskStore.createIndex('by-status', 'status');

        const planStore = db.createObjectStore('plans', { keyPath: 'id' });
        planStore.createIndex('by-status', 'status');
        planStore.createIndex('by-start', 'startAt');

        const sessionStore = db.createObjectStore('plan_sessions', { keyPath: 'id' });
        sessionStore.createIndex('by-plan', 'planId');

        const historyStore = db.createObjectStore('history', { keyPath: 'id' });
        historyStore.createIndex('by-plan', 'planId');

        db.createObjectStore('preferences', { keyPath: 'key' });
        db.createObjectStore('notification_settings', { keyPath: 'key' });
        db.createObjectStore('sync_events', { keyPath: 'id' });
        db.createObjectStore('meta', { keyPath: 'clientId' });
      }
    });
  }
  return dbPromise;
};
